import { useGetCurrentUserQuery } from 'core/api/UserApi'
import { useMemo } from 'react'
import { Role } from 'core/api/dto/UserDto'

/**
 * Только Управляющий (SUPERVISOR) и Бухгалтер (ACCOUNTANT) могут редактировать цену
 */
export const useCanEditPrice = (): boolean | null => {
  const { data: currentUser } = useGetCurrentUserQuery()

  return useMemo(
    () =>
      currentUser
        ? !!currentUser.userRoles.roleType.find(
            (item) => item === Role.SUPERVISOR || item === Role.ACCOUNTANT,
          )
        : null,
    [currentUser],
  )
}
